const baseStyle = {
  container: {
    lineHeight: 'normal',
    borderRadius: '.6em',
    px: '.8em',
    py: '.4em',
  },
  label: {
    lineHeight: 'normal',
  },
};

const sizes = {
  sm: baseStyle,
  md: baseStyle,
  lg: baseStyle,
};

export default {
  baseStyle,
  sizes,
};
